import { RegistrationSourceDto } from '../dtos/registration-source.dto';
import { VisibilityDto } from '../dtos/visibility.dto';
import { RegistrationSource } from '../models/registration-source';
import { Visibility } from '../models/visibility';

/**
 * Map registration source from dto.
 * @param {RegistrationSourceDto} dto Dto.
 * @returns {RegistrationSource}
 */
function registrationSourceFromDto(dto) {
  return new RegistrationSource({
    id: dto.id,
    name: dto.name,
  });
}

/**
 * Map visibility from dto.
 * @param {VisibilityDto} dto Dto.
 * @returns {Visibility}
 */
function visibilityFromDto(dto) {
  return new Visibility({
    name: dto.name,
    value: dto.value,
  });
}

export const lookupMapper = {
  registrationSourceFromDto,
  visibilityFromDto,
};
